import { ComponentProps } from 'react';
import { DataInteractive } from '@headlessui/react';

import { Link as LinkComponent, LinkProps } from '@northladder/i18n';

/**
 * -----------------------------------------------------------------------------
 * Base next/link component that is injected with the current locale by next-intl
 * and the interactive elements by headlessui.
 *
 * https://catalyst.tailwindui.com/docs#client-side-router-integration
 */
/**
 * An enhanced link component that supports internationalization and Headless UI interactivity.
 */
export function Link({ ref, ...props }: LinkProps & ComponentProps<'a'>) {
  return (
    <DataInteractive>
      <LinkComponent {...props} ref={ref} />
    </DataInteractive>
  );
}

/**
 * Custom type built around the composed `ui/link` component
 */
/**
 * The type definition for the Link component.
 */
export type TLinkType = typeof Link;
